import api from "./api";
import { formSections as defaultSections } from "./mock";

export const FIELD_TYPES = [
  { value: "text", label: "Short text" },
  { value: "textarea", label: "Long text" },
  { value: "tel", label: "Phone" },
  { value: "number", label: "Number" },
  { value: "url", label: "Link / URL" },
  { value: "select", label: "Dropdown" },
  { value: "checkboxes", label: "Checkboxes (multi-select)" },
  { value: "file", label: "File upload" },
];

// Load the live schema from the backend; fall back to the built-in default.
export async function loadSchema() {
  try {
    const { data } = await api.get("/form-schema");
    if (data && Array.isArray(data.sections) && data.sections.length) return data.sections;
  } catch (e) {}
  return defaultSections;
}

export { defaultSections };

export const slugify = (label) =>
  (label || "field")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "")
    .slice(0, 24) || "field";
